export const navItems = [
  {
    title: "Exhibit themes",
    path: "/",
  },
  {
    title: "About the exhibit",
    path: "/about",
  },
  // {
  //   title: "Cinema room",
  //   path: "/cinema",
  // },
  {
    title: "Pharmacy in time",
    path: "/pharmacy-in-time",
  },
];
